import { Reveal } from "@/lib/motion";
import { INDUSTRIES } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

export default function Industries() {
  return (
    <section className="relative z-10 py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <span className="overline">Industry Solutions</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-slate-900 tracking-tight mt-3">
            Website intelligence tuned to your industry
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-14">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.slug} delay={(i % 2) * 0.08}>
              <div className="relative h-64 rounded-2xl border border-slate-200 overflow-hidden group cursor-pointer soft-shadow" data-testid={`industry-${ind.slug}`}>
                <img src={ind.image} alt={ind.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/85 via-slate-900/40 to-transparent" />
                <div className="relative z-10 h-full flex flex-col justify-end p-7">
                  <div className="flex items-start justify-between">
                    <h3 className="font-heading text-2xl font-bold text-white">{ind.name}</h3>
                    <ArrowUpRight className="text-white/70 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                  </div>
                  <p className="text-xs text-white/70 mt-2 font-medium">{ind.modules}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
